import React from 'react'
import About from '../../componetns/about'
import { Link } from 'react-router-dom'
import BackButton from "../img/back-button.png"
import LogoDarkAnimator from '../../componetns/logoDarkAnimator'
import MobileHeader from './mobileHeader'
import Logo from '../../componetns/logo'

const MobileAbout = () => {
    return (
        <div className='mobile_about'>
            <div className="Mobile_header">
                <Link to="/" className=" mobile_back" style={{ border: 'none', marginTop: '.5rem', marginLeft: '.5rem' }} >
                    <img src={BackButton} alt="" />
                </Link>
                {/* <img src={LogoMain} alt="logo" /> */}
                <Link to="/">
                    <LogoDarkAnimator />
                </Link>
                <div className=""></div>
            </div>
            <div className="p-3 mobile_about">
                <About />
            </div>

        </div>
    )
}

export default MobileAbout